import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import ApiUrls from "../../../Utils/axr";
import { errorConditionGTM } from "../../../Utils/googleTags";

type MoversContentState = {
    moversContent: any;
    loading: boolean;
    error: any;
}

const initialState: MoversContentState = {
    moversContent: null,
    loading: false,
    error: null,
};

const host = window?.location?.host;
const file = "movers-content.json";

export const getMoversContent = createAsyncThunk(
    "get/movers/content",
    async () => {
        try {
            const response = await useFetchAemBrspdContents({
                [ApiUrls.aem_content]: `${file}?appName=${host}`,
            });
            return response?.data;
        } catch (error) {
            throw error;
        }
    }
);

const moversSlice = createSlice({
    name: "movers-content/Details",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getMoversContent.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getMoversContent.fulfilled, (state, action) => {
            state.moversContent = action.payload;
            state.loading = false;
            state.error = null;
        });
        builder.addCase(getMoversContent.rejected, (state, action) => {
            errorConditionGTM(
                "BRSPD_Movers_EC_Flow",
                "movers-content",
                action?.error?.message,
                action?.type
            );
            state.moversContent = null;
            state.loading = false;
            state.error = action.error;
        });
    },
});

export default moversSlice.reducer;